<template>
  <div>
    <h5>
      {{ "check_auth_clinet" | setText("Аутентификация клиента в системе") }}
      {{ order.client.phone }}
      {{ partner.name }}
    </h5>
    <div class="install-control">
      <button @click="next" class="btn btn-success">
        {{ "next_step" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import { logger } from "../../../plugins/functions";

export default {
  props: {
    partner: {
      default: function () {
        return {};
      },
    },
    order: {
      default: function () {
        return {};
      },
    },
    index: {
      default: 0,
    },
    transaction: {
      default: null,
    },
  },
  name: "filter",
  async created() {},
  methods: {
    async sha512(str) {
      const hash = await crypto.subtle
        .digest("SHA-512", new TextEncoder("utf-8").encode(str))
        .then((buf) => {
          return Array.prototype.map
            .call(new Uint8Array(buf), (x) => ("00" + x.toString(16)).slice(-2))
            .join("");
        });

      return hash;
    },
    next() {
      this.save();
    },
    async save() {
      this.$loading(true);

      logger(this.$http, {
        name: "Авторизация пользователя в #INTEND",
        description: "Начало запроса",
        model_type: "order",
        model_id: this.order.id,
      });

      const username = this.order.client.phone.replace("+998", ""); //номер телефона клиента

      this.$http
        .post(
          `${this.partner["endpoint_url"]}member/auth`,
          {
            username: username,
            token: await this.sha512(
              `998${username}$${this.partner["api_secret_key"]}`
            ), //генерация токена
          },
          {
            headers: {
              "api-key": `${this.partner["api_public_key"]}`,
              "Content-Type": "application/json",
              Accept: "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.data) {
            this.message = "Получен успешно токен";
            this.$emit("getHash", response.data.data.token);

            if (
              this.transaction &&
              this.transaction["client_confirmed"] === false
            ) {
              this.$emit("next", 3);
            } else if (
              this.transaction &&
              this.transaction["client_confirmed"] === true
            ) {
              this.$emit("next", 6);
            } else {
              this.$emit("next", 3);
            }
          } else if (response.data.error) {
            this.message = response.data.error["message"];
          } else {
            this.message = "Ошибка авторизации клиента";
            this.$emit("next", 0);
          }

          if (this.message) {
            logger(this.$http, {
              name: "Авторизация пользователя в #INTEND",
              description: this.message,
              model_type: "order",
              model_id: this.order.id,
            });
            this.$notify({
              title: this.partner.name,
              message: this.message,
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
            });
          }
        })
        .catch((error) => {
          logger(this.$http, {
            name: "Авторизация пользователя в #INTEND",
            description: "Системная ошибка в #INTEND",
            model_type: "order",
            model_id: this.order.id,
          });
          alert("Ошибка партнера");
        })
        .finally(() => {
          this.$loading(false);
        });
    },
  },
  data() {
    return {
      message: "",
    };
  },
};
</script>
<style lang="scss">
</style>
